import React from 'react';

import Loadable from 'react-loadable';
import {Route} from 'react-router-dom';

import {searchRoot} from 'static/three-oh/src/modules/constants/routePaths';

const SearchRoute = (
  <Route
    key="Search"
    path={searchRoot}
    component={
      Loadable({
        loader: () => import(
          /* webpackChunkName: "Search" */
          './SearchRouter'
        ),
        loading: () => null
      })
    }
  />
);

export default SearchRoute;
